export const GET_BUILD_BY_PROJECT_ID_LOADING = "GET_BUILD_BY_PROJECT_ID_LOADING"
export const GET_BUILD_BY_PROJECT_ID_SUCCESS = "GET_BUILD_BY_PROJECT_ID_SUCCESS"
export const GET_BUILD_BY_PROJECT_ID_FAILED = "GET_BUILD_BY_PROJECT_ID_FAILED"
export const GET_BUILD_BY_PROJECT_ID_EMPTY = "GET_BUILD_BY_PROJECT_ID_EMPTY"
export const GENERATE_BUILD_BY_PROJECT_ID_LOADING = "GENERATE_BUILD_BY_PROJECT_ID_LOADING"
export const GENERATE_BUILD_BY_PROJECT_ID_SUCCESS = "GENERATE_BUILD_BY_PROJECT_ID_SUCCESS"
export const GENERATE_BUILD_BY_PROJECT_ID_FAILED = "GENERATE_BUILD_BY_PROJECT_ID_FAILED"
export const GENERATE_BUILD_BY_PROJECT_ID_EMPTY = "GENERATE_BUILD_BY_PROJECT_ID_EMPTY"
export const RESET_BUILD_BY_PROJECT_ID = "RESET_BUILD_BY_PROJECT_ID"
